<template>
  <nav
    ref="navRef"
    class="h-screen fixed top-0 left-0 flex flex-col gap-4 py-3 select-none z-50 duration-300 ease-in-out rounded-none border-r border-surface-200 bg-surface-50 shadow-none translate-x-0"
    :class="navCollapsed ? 'w-16 px-2' : 'w-64 px-4'"
  >
    <!-- LOGO AND LAYOUT TOGGLE -->
    <div class="w-full flex flex-col gap-3">
      <div
        class="h-9 flex items-center"
        :class="navCollapsed ? 'justify-center' : 'justify-between px-1'"
      >
        <div
          v-if="!navCollapsed"
          class="bg-contain bg-no-repeat h-full cursor-pointer flex-grow"
          style="background-image: url('/logo/studio_full_light.png')"
          @click="router.push({ name: 'index' })"
        />
        <LayoutToggle :class="navCollapsed ? '' : 'ml-2'" />
      </div>
      <slot name="top" />
    </div>

    <ul class="flex flex-col gap-6 w-full">
      <slot name="nav-items" />
    </ul>

    <!-- Footer pinned to the bottom (e.g. account menu). -->
    <div
      v-if="$slots.footer"
      class="mt-auto w-full"
    >
      <slot name="footer" />
    </div>
  </nav>
</template>

<script setup lang="ts">
import { useLayoutPreferencesStore } from '~/stores/layoutPreferences'

const layoutStore = useLayoutPreferencesStore()
const router = useRouter()

// In the "minimized" (float) layout mode the settings rail collapses to an
// icon-only rail rather than sliding away. Children hide their labels off this
// injected flag.
const navCollapsed = computed(() => layoutStore.currentLayout === 'float')

provide('navCollapsed', navCollapsed)
</script>
